/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OperatorRwrActivationDetails } from './operatorRwrActivationDetails';
import { EdrDeploymentRegion } from './edrDeploymentRegion';
import { RansomwareRecoveryDeploymentStatesEnum } from './ransomwareRecoveryDeploymentStatesEnum';


export interface OperatorRwrDeploymentDetails { 
    activation_details?: OperatorRwrActivationDetails;
    activation_status?: RansomwareRecoveryDeploymentStatesEnum;
    /**
     * List of EDR regions managed by Customer.
     */
    customer_managed_regions?: Array<EdrDeploymentRegion>;
    /**
     * List of EDR regions managed by VMware.
     */
    vmware_managed_regions?: Array<EdrDeploymentRegion>;
}
export namespace OperatorRwrDeploymentDetails {
}


